import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import Loader from 'react-loader-spinner'

function LoadingSpinner ({ size = 5, color = 'purple' }) {
  const _className = classNames(
    'spinner',
    { [`w-${size} h-${size}`]: size },
    { white: color === 'white' },
    { purple: color === 'purple' }
  )

  return (
    <div className={_className}>
      <Loader
        type='Oval'
        color={color === 'purple' ? '#5c69e0' : '#ffffff'}
        height='100%'
        width='100%'
      />
    </div>
  )
}

LoadingSpinner.propTypes = {
  /**
     * sizes taken specifically from tailwind w- h- docs. ex '1/2'
     */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
     * Color of the spinner
     */
  color: PropTypes.oneOf(['white', 'purple']),
  /**
     * Width of the line in the spinner
     */
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
}

export default LoadingSpinner
